import { apiSlice } from './apiSlice.js';
import { ADDRESS_URL } from '../constants.js';

export const addressApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserAddresses: builder.query({
            query: () => ({
                url: ADDRESS_URL
            }),
            keepUnusedDataFor: 5,
            providesTags: ['Address']
        }),
        getAddressById: builder.query({
            query: (id) => ({
                url: `${ADDRESS_URL}/${id}`
            }),
            keepUnusedDataFor: 5,
            providesTags: ['Address']
        }),
        addUserAddress: builder.mutation({
            query: (address) => ({
                url: ADDRESS_URL,
                method: 'POST',
                body: address
            }),
            invalidatesTags: ['Address']
        }),
        getShippablePincodes: builder.query({
            query: () => ({
                url: `${ADDRESS_URL}/pincode`
            }),
            keepUnusedDataFor: 5,
            providesTags: ['Pincode']
        }),
        validatePincode: builder.mutation({
            query: (pinCode) => ({
                url: `${ADDRESS_URL}/pincode`,
                method: 'POST',
            body: { pinCode },
            }),
            invalidatesTags: ['Pincode']
        })
    })
})

export const {
    useGetUserAddressesQuery,
    useGetAddressByIdQuery,
    useAddUserAddressMutation,
    useGetShippablePincodesQuery,
    useValidatePincodeMutation
} = addressApiSlice;